import { createFileRoute } from "@tanstack/react-router";
import { PlaylistsPage } from "@/features/calls/PlaylistsPage";

// /calls/playlists: the coaching playlists of calls (X19-C06)
export const Route = createFileRoute("/_app/calls/playlists")({
  component: () => <PlaylistsPage />,
});
